const BlogPage = () => {
  return (
    <section className="section">
      <div style={{ maxWidth: 880, margin: '0 auto' }}>
        <p style={{ fontSize: 13, letterSpacing: '0.22em', textTransform: 'uppercase', color: '#a5b4fc' }}>
          Insights
        </p>
        <h1 style={{ fontSize: 30, marginTop: 10, marginBottom: 10 }}>Virtual Digital Hub Blog</h1>
        <p style={{ fontSize: 15, color: '#cbd5f5' }}>
          In-depth breakdowns on paid media, Shopify growth, and the systems behind high-performing digital brands. Blog
          posts can be managed from the admin dashboard.
        </p>
      </div>
    </section>
  );
};

export default BlogPage;

